/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createGlobalVocabulary = /* GraphQL */ `
  mutation CreateGlobalVocabulary(
    $input: CreateGlobalVocabularyInput!
    $condition: ModelGlobalVocabularyConditionInput
  ) {
    createGlobalVocabulary(input: $input, condition: $condition) {
      id
      word
      translation
      textToSpeech
      wordImage
      setName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGlobalVocabulary = /* GraphQL */ `
  mutation UpdateGlobalVocabulary(
    $input: UpdateGlobalVocabularyInput!
    $condition: ModelGlobalVocabularyConditionInput
  ) {
    updateGlobalVocabulary(input: $input, condition: $condition) {
      id
      word
      translation
      textToSpeech
      wordImage
      setName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGlobalVocabulary = /* GraphQL */ `
  mutation DeleteGlobalVocabulary(
    $input: DeleteGlobalVocabularyInput!
    $condition: ModelGlobalVocabularyConditionInput
  ) {
    deleteGlobalVocabulary(input: $input, condition: $condition) {
      id
      word
      translation
      textToSpeech
      wordImage
      setName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserVocabulary = /* GraphQL */ `
  mutation CreateUserVocabulary(
    $input: CreateUserVocabularyInput!
    $condition: ModelUserVocabularyConditionInput
  ) {
    createUserVocabulary(input: $input, condition: $condition) {
      id
      owner
      word
      translation
      progress
      setName
      isHidden
      wordImage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserVocabulary = /* GraphQL */ `
  mutation UpdateUserVocabulary(
    $input: UpdateUserVocabularyInput!
    $condition: ModelUserVocabularyConditionInput
  ) {
    updateUserVocabulary(input: $input, condition: $condition) {
      id
      owner
      word
      translation
      progress
      setName
      isHidden
      wordImage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserVocabulary = /* GraphQL */ `
  mutation DeleteUserVocabulary(
    $input: DeleteUserVocabularyInput!
    $condition: ModelUserVocabularyConditionInput
  ) {
    deleteUserVocabulary(input: $input, condition: $condition) {
      id
      owner
      word
      translation
      progress
      setName
      isHidden
      wordImage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSets = /* GraphQL */ `
  mutation CreateSets(
    $input: CreateSetsInput!
    $condition: ModelSetsConditionInput
  ) {
    createSets(input: $input, condition: $condition) {
      id
      setName
      setImage
      numberOfWords
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSets = /* GraphQL */ `
  mutation UpdateSets(
    $input: UpdateSetsInput!
    $condition: ModelSetsConditionInput
  ) {
    updateSets(input: $input, condition: $condition) {
      id
      setName
      setImage
      numberOfWords
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSets = /* GraphQL */ `
  mutation DeleteSets(
    $input: DeleteSetsInput!
    $condition: ModelSetsConditionInput
  ) {
    deleteSets(input: $input, condition: $condition) {
      id
      setName
      setImage
      numberOfWords
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSentences = /* GraphQL */ `
  mutation CreateSentences(
    $input: CreateSentencesInput!
    $condition: ModelSentencesConditionInput
  ) {
    createSentences(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      sentence
      translation
      number
      topic
      __typename
    }
  }
`;
export const updateSentences = /* GraphQL */ `
  mutation UpdateSentences(
    $input: UpdateSentencesInput!
    $condition: ModelSentencesConditionInput
  ) {
    updateSentences(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      sentence
      translation
      number
      topic
      __typename
    }
  }
`;
export const deleteSentences = /* GraphQL */ `
  mutation DeleteSentences(
    $input: DeleteSentencesInput!
    $condition: ModelSentencesConditionInput
  ) {
    deleteSentences(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      sentence
      translation
      number
      topic
      __typename
    }
  }
`;
export const createArticles = /* GraphQL */ `
  mutation CreateArticles(
    $input: CreateArticlesInput!
    $condition: ModelArticlesConditionInput
  ) {
    createArticles(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      articleName
      articleText
      isRead
      category
      __typename
    }
  }
`;
export const updateArticles = /* GraphQL */ `
  mutation UpdateArticles(
    $input: UpdateArticlesInput!
    $condition: ModelArticlesConditionInput
  ) {
    updateArticles(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      articleName
      articleText
      isRead
      category
      __typename
    }
  }
`;
export const deleteArticles = /* GraphQL */ `
  mutation DeleteArticles(
    $input: DeleteArticlesInput!
    $condition: ModelArticlesConditionInput
  ) {
    deleteArticles(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      articleName
      articleText
      isRead
      category
      __typename
    }
  }
`;
